<template>
    <page-section class="page-section--xs">
        <template slot="containerImmersive">
            <div class="pb-4 pb-md-5">
                <list-head v-bind="{ loading }" v-on="{ excel }" />
            </div>
            <v-simple-table v-bind="{ headers }" dense class="v-data-table--default v-data-table--no-hover inventory-list-table">
                <thead>
                    <tr>
                        <th v-for="header in headers" :key="header.value">
                            {{ header.text }}
                        </th>
                        <th>선택</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(product, i) in products">
                        <template v-for="(purchase, j) in product.purchases">
                            <tr :key="`product-${i}-${purchase._id}`">
                                <td v-if="j == 0" :rowspan="product.purchases.length">{{ product?.fullName }}</td>
                                <!-- <td v-if="j == 0" :rowspan="product.purchases.length">{{ product?.code || "-" }}</td> -->
                                <td>{{ purchase?.createdAt?.toDate?.() || purchase?.createdAt || "-" }}</td>
                                <td>{{ (purchase?.amount - purchase?.amount_out)?.format?.() || 0 }}</td>
                                <td>{{ purchase?.purchasePrice__unit?.format?.() || 0 }}</td>
                                <td>{{ (purchase?.purchasePrice__unit * (purchase?.amount - purchase?.amount_out))?.format?.() || 0 }}</td>
                                <td>
                                    <v-simple-checkbox :value="getIsSelected(purchase)" v-bind="attrs_input" @click="toggleSelect(purchase)" />
                                </td>
                            </tr>
                        </template>
                    </template>
                </tbody>
            </v-simple-table>

            <div class="pagination-wrap pagination-wrap--sm">
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
            </div>
        </template>
    </page-section>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables";

import PageSection from "@/components/client/templates/page-section.vue";

import ListHead from "./list/list-head.vue";

const headers = [
    //
    { value: "fullName", text: "상품명" },
    // { value: "code", text: "상품코드" },
    { value: "createdAt", text: "입고일", formatter: (value) => value?.toDate?.() || value || "-" },
    { value: "amount", text: "재고수량", formatter: (value, item) => (item?.amount - item?.amount_out)?.format?.() || 0 },
    { value: "purchasePrice__unit", text: "평균 매입 단가", formatter: (value) => value?.format?.() || "-" },
    { value: "purchasePrice__total", text: "총액(수량X단가)", formatter: (value, item) => (item?.purchasePrice__unit * (item?.amount - item?.amount_out))?.format?.() || 0 },
].map((item) => ({ ...item, formatter: item?.formatter ?? ((value) => value || "-") }));

export default {
    components: {
        PageSection,
        ListHead,
    },
    props: {
        value: { type: Array, default: () => [] }, // selected
    },
    setup: () => ({
        attrs_input,
        headers,
    }),
    data: () => ({
        products: [],
        selected: [],

        summary: {
            totalCount: 0,
            entireAmount: 0,
            overallPrice: 0,
        },

        limit: 10,

        loading: false,
    }),
    computed: {
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            if (query.searchValue) query.searchKey = "fullName";

            delete query.page;

            return { ...query };
        },
    },
    methods: {
        init() {
            this.products = [];
            this.selected = [];

            this.summary = {
                totalCount: 0,
                entireAmount: 0,
                overallPrice: 0,
            };
        },
        sync() {
            this.selected = [...this.value];
        },
        emit() {
            this.$emit("input", this.selected);
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { products, summary } = await api.v1.me.stocks.products.gets({
                    headers: { skip, limit },
                    params,
                });

                this.products = products.map((product) => ({
                    ...product,
                    purchases: product.purchases.sort((a, b) => (this.$dayjs(a.createdAt).isBefore(b.createdAt, "millisecond") ? 1 : -1)),
                }));
                this.summary = summary;
            } finally {
                this.loading = false;
                this.$emit("setSummary", this.summary);
            }
        },
        async excel() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { params } = this;
                let { products } = await api.v1.me.stocks.products.gets({
                    params,
                });

                let purchases = products.flatMap((item) => item.purchases);
                let fileName = `재고리스트`;
                this.$excel(purchases, this.headers, fileName);
            } finally {
                this.loading = false;
                this.$emit("setSummary", this.summary);
            }
        },
        getIsSelected({ _id }) {
            return this.selected.some((item) => item._id == _id);
        },
        toggleSelect(purchase) {
            let index = this.selected.findIndex((item) => item._id == purchase._id);

            if (-1 < index) this.selected.splice(index, 1);
            else this.selected.push(purchase);

            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
        params() {
            this.search();
        },
        page() {
            this.search();
        },
    },
    mounted() {
        this.init();
        this.sync();
        this.search();
    },
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped>
.inventory-list-table {
    --border-color: var(--v-grey-lighten4);
    th,
    td {
        text-align: center !important;
        padding: 12px !important;
        &:not(:last-child) {
            border-right: 1px solid var(--border-color);
        }
    }
    th {
        white-space: nowrap;
    }
    thead {
        > tr {
            > th {
                // &:nth-child(1) {
                //     width: calc(184.5 / 894 * 100%);
                // }
                // &:nth-child(2) {
                //     width: calc(160.5 / 894 * 100%);
                // }
                // &:nth-child(3) {
                //     width: calc(108 / 894 * 100%);
                // }
                // &:nth-child(4) {
                //     width: calc(184.5 / 894 * 100%);
                // }
                // &:nth-child(5) {
                //     width: calc(184.5 / 894 * 100%);
                // }
                // &:nth-child(6) {
                //     width: calc(48 / 894 * 100%);
                // }
            }
        }
    }
}
</style>
